export const LOG_LEVEL = {
  DEBUG: 'DEBUG',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
};

export const log = (...args: any[]) => {
  const input = [...args];

  if (input.length < 1) {
    return;
  }

  // openpix vs woovi
  // eslint-disable-next-line
  console.log(`[Woovi]`, ...args);
};
